module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('article', {
    staticClass: "tile is-child notification is-black is-size-4"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("Want better quality? Same here.")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "btn-container"
  }, [_c('router-link', {
    staticClass: "button is-black is-block is-large meeting",
    attrs: {
      "to": "/pay"
    }
  }, [_vm._v("\n              Support US!\n            ")])], 1)])])]), _vm._v(" "), _vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12 content"
  }, [_c('p'), _c('h1', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/playlist?list=PLfCtn83lMV3BqBe45jgaNw4LqPNnhq6IG"
    }
  }, [_vm._v("Playlist of Archived Streams\n      ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.youtube.com/channel/UCpun3Ro3aUJPoFVZwgqd98A"
    }
  }, [_vm._v("📥 Subscribe to Progressbar Channel\n      ")])]), _vm._v(" "), _c('iframe', {
    staticClass: "mainiframe",
    attrs: {
      "height": "800",
      "src": "https://www.youtube-nocookie.com/embed/videoseries?list=PLfCtn83lMV3BqBe45jgaNw4LqPNnhq6IG",
      "loading": "lazy",
      "frameborder": "0",
      "allow": "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
      "allowfullscreen": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("👼 Digital slides (200€+)")]), _vm._v(" "), _c('p', [_vm._v("🧠 Better audio quality (300€+)")]), _vm._v(" "), _c('p', [_vm._v("👩‍🎨 Better camera (600€+)")]), _vm._v(" "), _c('p', [_vm._v("📚 More camera angles (600€+/ks)")]), _vm._v(" "), _c('p', [_vm._v("🎧 General improvements (100€/)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-8"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12 content"
  }, [_c('h1', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Also recorded in Progressbar:")])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6"
  }, [_c('iframe', {
    attrs: {
      "height": "360",
      "src": "https://www.youtube-nocookie.com/embed/videoseries?list=PLfCtn83lMV3CzkXkGdkdUnNZvD5c4hBbC",
      "loading": "lazy",
      "frameborder": "0",
      "allow": "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
      "allowfullscreen": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column is-6"
  }, [_c('iframe', {
    attrs: {
      "height": "360",
      "src": "https://www.youtube.com/embed/videoseries?list=PL7Q4UCybIXBG5SkXQX0CqLBQbaCVWYjvF",
      "loading": "lazy",
      "frameborder": "0",
      "allow": "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
      "allowfullscreen": ""
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-730a42ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Video.vue
// module id = 253
// module chunks = 12